import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import usePageModal from 'features/Modal/hooks/usePageModal'
import { MODAL_MODE } from 'components/Modal/config'

import './style.scss'

export const ActivitySendLetterBackButton = ({ id }: { id: number }) => {
  const { t } = useTranslation()
  const { generatePageModalUrl } = usePageModal()
  const navigate = useNavigate()

  return (
    <button
      className="ActivitiesList__item__sendLetterBackButton"
      onClick={() =>
        navigate(
          generatePageModalUrl(MODAL_MODE.CREATE_USER_REVIEW, {
            userId: id,
            gift: true,
            returnPath: location.pathname + location.search,
          })
        )
      }
    >
      {t('activity_list.send_letter_back_button')}
    </button>
  )
}
